<template>
  <nuttrema-layout-content>
    <template slot="header">
      <stuff-to-eat-standard-header
        :meta="meta"
        :showEdit="!_isEmpty(StuffToEatExchanges.data)"
        :StuffToEatDetails="StuffToEatDetails">
        <div slot="edit" class="content-header-item">
          <permissions-control-wrapper
             action="label.edit"
            :required-general="$PERMISSIONS_GENERAL.EDIT_EXCHANGES"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <el-button
               slot="allowed"
               size="mini"
              :type="edit ? 'nuttrema-orange' : ''"
              @click="edit = !edit">
              {{ $t('label.edit') }}
            </el-button>

            <el-button
              slot="not-allowed"
              size="mini"
              type="info"
              class="is-icon-mr-075">
              <i class="far fa-lock-alt"></i>{{ $t('label.edit') }}
            </el-button>
          </permissions-control-wrapper>
        </div>
      </stuff-to-eat-standard-header>

    </template>

    <exchanges-list
       slot="central"
      :edit="edit"
      :meta="meta"
      :state="StuffToEatExchanges">
    </exchanges-list>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import ExchangesList from './cmpt-exchanges-list';

export default {
  name: 'page-stuff-to-eat-exchanges',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
    entityType: {
      required: false,
      default: null,
    },
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatExchanges() {
      return this.$store.getters.StuffToEatExchanges(this.id);
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  components: {
    ExchangesList,
    NuttremaLayoutContent,
    StuffToEatStandardHeader,
  },
  created() {
    this.$store.dispatch('GetStuffToEatExchanges', { id: this.id, type: this.entityType });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatExchanges', { id: this.id });
  },
};
</script>

<style lang="scss" scoped>
  .participant-assigned-programs {
    display: flex;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/exchanges/page-stuff-to-eat-exchanges.vue